		//Handle the Mobile Menu

jQuery("document").ready(function()
{		
		
		jQuery(".mobile-menu-button").click(function()
		{
			if (jQuery(this).hasClass('menu-open'))
			{
				jQuery(this).removeClass('menu-open');
				jQuery(".menu-wrapper").removeClass('menu-open');
              jQuery(".store-icons").removeClass("menu-open");
			}
			else
			{
				jQuery(this).addClass('menu-open');
				jQuery(".menu-wrapper").addClass("menu-open");
              	jQuery(".store-icons").addClass("menu-open");
			}
			
		});
	//JavaScript to be fired on all pages
	//===========Changing Menu header items to be more accessible==================

	let listItem = document.querySelector('.site-nav');
	// listItem = listItem.firstChild;
	let menuContent = document.querySelector('.menu-content');
	let menuWrapper = document.querySelector('menu-wrapper');
	console.log(listItem.children)
	listItem = listItem.children[0]
	listItem.innerHTML = '<button class="training-button" aria-expanded="false" aria-controls="training-level-2" style="text-transform:uppercase;font-family:montserrat;font-weight:900;font-size:19px;-webkit-font-smoothing:antialiased;background:none;border:none;color:#fff;padding-bottom:9px;">Training &#9660;</button><ul id="training-level-2" class="sub-menu"><li id="menu-item-4507" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4507 aria-alltraining"><a href="https://www.zingtrain.com/training/"">All Training</a></li><li id="menu-item-4505" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4505 aria-inperson"><a href="https://www.zingtrain.com/in-person-seminars/">In-Person Seminars</a></li><li id="menu-item-4506" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4506"><a href="https://www.zingtrain.com/virtual-workshops/">Virtual Workshops</a></li><li id="menu-item-4502" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-4502"><a href="https://www.zingtrain.com/personalized-training">For Your Team</a></li><li id="menu-item-4515" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-4515"><a href="//zingtrain.com/calendar">Calendar</a></li></ul>';

	let buttonItem = document.querySelector('.training-button');

	var menuExpand = document.querySelector('.site-nav');
	menuExpand = menuExpand.children[0]
	console.log("checking")
	console.log(menuExpand)
	var menuBlock = document.querySelector('.sub-menu');

	function dropDown() {
	  menuBlock.classList.toggle('dropdown-show');
	}
	function ariaExpanded() {
	  if (buttonItem.getAttribute('aria-expanded') == 'false') {
	    console.log(buttonItem.getAttribute('aria-expanded'))
	    buttonItem.setAttribute('aria-expanded', 'true')
	  }
	  else if (buttonItem.getAttribute('aria-expanded') == 'true') {
	    buttonItem.setAttribute('aria-expanded', 'false')
	  }
	}
	menuContent.addEventListener('focus', function(){
	  console.log('listening')
	  document.addEventListener('keyup', function(e){
	      if (e.keyCode == 13 && !menuExpand.classList.contains('is-active')){
	        dropDown();        
	        menuExpand.classList.toggle('is-active')
	        buttonItem.setAttribute('title','Contains current page link')
	        console.log('1')
	        ariaExpanded();
	      }
	      if (e.keyCode == 27 && menuExpand.classList.contains('is-active')){
	        buttonItem.toggleAttribute('title')
	        dropDown();
	        menuExpand.classList.toggle('is-active')
	        console.log('2')

	        ariaExpanded();
	      }
	  }, true)
	}, true)
	menuExpand.addEventListener('click', function(){
	  if(buttonItem.hasAttribute('title')){
	    buttonItem.toggleAttribute('title')
	  }
	  else {
	    buttonItem.setAttribute('title', 'Contains current page link')
	  }
	  menuExpand.classList.toggle('is-active');
	  dropDown();
	  console.log('3')

	  ariaExpanded();
	}, false);

	var navExpand = document.querySelector('.mobile-menu-button');
	var navItems = document.querySelector('.site-nav');


	function openNav() {
	  navItems.classList.toggle('open-menu');
	}

	navExpand.addEventListener('click', function (){
	  menuContent.classList.toggle('menu-open');
	  openNav();
	});
	//add classes to menu for the below classes
	let pages = {'home':'.menu-item-home', 'training':'.aria-training', 'keynote-landing':'.aria-keynotes', 'blog':'.aria-resources', 'about-us':'.aria-aboutus'}
	let sections = {'#2-day-seminars':'.aria-inperson', '#virtual-training':'.aria-virtual', '#for-your-team':'.aria-foryourteam', '#view-all':'aria-viewall'}
	if (sections[location.hash]) {
	  document.querySelector(sections[location.hash]).setAttribute('aria-current', 'page')
	}
	else {Object.keys(pages).forEach(function(key) {
	  if (document.querySelector('body').classList.contains(key)){
	    document.querySelector(pages[key]).setAttribute('aria-current', 'page')
	    }
	  })
	}

	window.addEventListener('resize', function() {
	  if(window.innerWidth > 925) {
	    document.querySelector('.site-nav').classList.remove('open-menu');

	  }
	}, true)
	//Check if in admin mode to adjust Training dropdown position
	if (document.getElementById('wpadminbar')) {
	  document.getElementById('training-level-2').style.top = '170px'
	}
});